import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { Input, makeStyles } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
// import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  "Oliver Hansen",
  "Van Henry",
  "April Tucker",
  "Ralph Hubbard",
  "Omar Alexander",
  "Carlos Abbott",
  "Miriam Wagner",
  "Bradley Wilkerson",
  "Virginia Andrews",
  "Kelly Snyder",
];

export default function MultipleSelectCheckmarks({
  label,
  data,
  handleInterests,
  interestsArray,
  name,
}) {
  // const [interestsArray, setInterestsArray] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    handleInterests(
      // On autofill we get a stringified value.
      name,
        typeof value === "string" ? value.split(",") : value
    );
  };

  return (
    <div
      style={{
        // border: "1px solid ",
        boxShadow: "0px 0px 34px rgba(174, 174, 174, 0.25)",
        borderRadius: "5px",
        margin: "10px auto",
        marginBottom: "10px",
        width: " 90%",
        // height: "55px",
        paddingTop: interestsArray.length === 0 ? "0px" : "20px",
        background: "#fff",
      }}
    >
      <FormControl sx={{ m: 0, width: "100%", paddingLeft: "10px" }}>
        <InputLabel
          style={{
            // zIndex: -10,
            zIndex: 0,
            marginLeft: "5px",
            fontSize: "16px",
            color: "#999999",
            fontWeight: "500",
          }}
          id="mutiple-select-label"
        >
          {label}
        </InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple
          value={interestsArray}
          onChange={handleChange}
          input={<Input style={{}} />}
          renderValue={(interestsArray) => 
            interestsArray
            .join(", ")
          }
          MenuProps={MenuProps}
          disableUnderline={true}
          style={{
            marginLeft: "8px",
            marginTop: interestsArray.length > 0 ? "5px" : "20px",
          }}
          IconComponent={() => (
            <ArrowDropDownIcon
              style={{
                // border: "1px solid red",
                marginTop: "-20px",
              }}
              color="disabled"
            />
          )}
        >
          {data.map((name) => (
            <MenuItem key={name.value} value={name.label}>
              <Checkbox checked={interestsArray.indexOf(name.label) > -1} />
              <ListItemText primary={name.localizedLabel} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
